import React from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import { practiceHubTabsData } from "../../../data/SidebarData";
import Tabs from "../../../Components/Common/Tabs";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";

const PracticeHubIndexMecha = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={practiceHubTabsData} />
      <StaticPageForm
        title="Mechanical Practice Hub"
        category="mechanical"
        subscription
        promo
        // typeData={data}
        // type="materials"
        // filter="subscription"
        // subscription
      />
    </div>
  );
};

export default PracticeHubIndexMecha;
